var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDevLogoNew = function SvgDevLogoNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 18,
    fill: "none",
    viewBox: "0 0 25 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_2426_1287)",
    fillRule: "evenodd",
    d: "M9.415 2.535C9.415 1.135 10.55 0 11.95 0a8.54 8.54 0 0 1 8.54 8.54 8.54 8.54 0 0 1-8.54 8.542H2.535a2.535 2.535 0 0 1 0-5.07h9.415a3.47 3.47 0 0 0 3.47-3.471 3.47 3.47 0 0 0-3.47-3.47 2.535 2.535 0 0 1-2.535-2.536",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CA72",
    fillRule: "evenodd",
    d: "M3.55 8.54A8.54 8.54 0 0 1 12.093 0a2.535 2.535 0 1 1 0 5.07 3.47 3.47 0 0 0-3.47 3.47 3.47 3.47 0 0 0 3.47 3.471h10.407v5.07H12.092a8.54 8.54 0 0 1-8.541-8.54",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CA72",
    d: "M24.747 13.943a.86.86 0 0 1 0 1.219l-1.683 1.673c-.542.54-1.466.155-1.466-.61V12.88c0-.765.924-1.149 1.466-.61z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2426_1287",
    x1: 15.536,
    x2: 14.014,
    y1: 5.721,
    y2: 12.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#00CA72",
    stopOpacity: 0.6
  })))));
};
export default SvgDevLogoNew;